import {SvgIconData} from '@shared-web/components/core/svg_icon';

export const contentSaveIcon: SvgIconData = {
  viewBox: '1 3 19 19',
  element: (
    <path d="M6 3h10.6L20 6.4V17a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3m0 1a2 2 0 0 0-2 2v11q.2 1.8 2 2h11a2 2 0 0 0 2-2V7l-3-3h-1v5H6zm1 0v4h7V4zm5 7a3 3 0 1 1 0 6 3 3 0 0 1 0-6m0 1a2 2 0 0 0-2 2q.2 1.8 2 2a2 2 0 0 0 2-2 2 2 0 0 0-2-2M6 22a5 5 0 0 1-5-5V7h1v10a4 4 0 0 0 4 4h10v1z" />
  ),
};
